import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Paper from '@mui/material/Paper'
import { createUseStyles } from 'react-jss'
import {
  CustomerAddress,
  DocumentDate,
  Footer,
  Header,
  Payment,
  Subject,
  TableBody,
  TableHeader,
  theme
} from '../../document/Document'
import { baseDocument } from '../../../utils/constants/misc'

const useStyles = createUseStyles(theme)

const Invoice = ({ document_param: invoice, company_param: company, logo_param: logo, settings_param: settings }) => {
  const customer = invoice.customer
  const classes = useStyles()

  const References = () => {
    if (invoice) {
      return (
        <>
          <Box className={classes.rightContainer}>
            <Typography className={classes.boldWithSpace}>Référence facture</Typography>
            <Typography className={classes.address}>{invoice.invoice_number}</Typography>
          </Box>
          {invoice.quote_id !== null && (
            <Box className={classes.rightContainerNoMT}>
              <Typography className={classes.boldWithSpace}>Référence devis</Typography>
              <Typography className={classes.address}>{invoice.quote.quote_number}</Typography>
            </Box>
          )}
        </>
      )
    }
  }

  return (
    <Paper className={classes.paper}>
      <Box className={classes.page}>
        <Header logo={logo} classes={classes} documentTitle={'FACTURE'} />
        <References />
        <DocumentDate date={invoice.invoice_date} classes={classes} />
        <CustomerAddress customer={customer} company={company} classes={classes} />
        <Subject document={invoice} classes={classes} />
        <TableHeader headers={baseDocument} classes={classes} />
        <TableBody headers={baseDocument} lines={invoice.lines} total={invoice.total_amount_net} classes={classes} />
        <Payment customer={customer} settings={settings} classes={classes} />
        <Footer company={company} classes={classes} />
      </Box>
    </Paper>
  )
}

export default Invoice
